import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/fonts/fonts.js';
import { ExamType } from '@ils/static/enums.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';
import { DateTime } from 'luxon';
import { switchMap } from 'rxjs';
import { ExamDay } from '../../db/examdays.js';

@customElement('ils-exam-days-embed')
export class ILSExamDaysEmbed extends ChemistryLitElement {
  @property({ type: String, attribute: 'exam-type' }) private readonly examType = new RXController(
    this,
    ExamType.FAMED,
  );
  @state() private readonly examDays = new RXController(
    this,
    this.examType.observable.pipe(switchMap(examType => ExamDay.subscribeAllPublishedExamDays(examType)({ start: 1 }))),
  );

  override render() {
    return html`
      <x-flex padding="xs" slot="image" space="md" end ${css({ textAlign: 'right' })}>
        <x-h3> Nächste Prüfungstermine </x-h3>
        ${(this.examDays.value ?? []).map(
          ed => html` <x-text> ${ed.start.toLocaleString(DateTime.DATE_FULL)} </x-text> `,
        )}
      </x-flex>
    `;
  }
}
